import React from 'react'
import { observer } from 'mobx-react'
import { restaurantConfig } from 'mobx/mall'
import { ConfirmModal } from '@cps'
import { ProductImage } from 'components'
import './index.scss'

const SoldOutModal: React.FC<any> = (props) => {
  const { errData } = props

  const renderProduct = (product: any[]) => {
    return product?.map((item: any) => {
      return (
        <div className='soldout-product-item' key={item.productNo + item.scaleNo}>
          <ProductImage type='mall' color={!item.pic && restaurantConfig.displayMode === 'waterfall' ? item.productNo : ''} width={40} imgSrc={item.pic} />
          <div className='product-name'>
            <strong>{item.productName || item.name}</strong>
            <div className='product-option'>{item.optionStr}</div>
          </div>
        </div>
      )
    })
  }

  return (
    <ConfirmModal
      title={i18n.t('cart.saleWarn')}
      cancelText={i18n.t('newCart.continueAdd')}
      confirmText={i18n.t('cart.ikonw')}
      children={(
        <div className='soldout-product-list'>
          {renderProduct(errData)}
        </div>
      )}
      className='mall-soldout-warn-modal'
    />
  )
}

export default observer(SoldOutModal)
